import React from 'react';
import '../style/Footer.css'; // Thêm file CSS để style cho Footer

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Phần Logo và tên trang */}
                <div className="footer-logo">
                    <img
                        src="/logo.png" // Đường dẫn đến logo của bạn
                        alt="Logo"
                        style={{ height: '90px', marginRight: '10px' }} // Điều chỉnh kích thước ảnh nếu cần
                    />
                    <h3 className="footer-name">MComic</h3>
                </div>

                {/* Phần thông tin */}
                <div className="footer-info">
                    <p>MComic - Nền tảng đọc truyện tranh trực tuyến với hàng ngàn bộ truyện hấp dẫn!</p>
                    <p>Chúng tôi luôn cập nhật liên tục những bộ truyện mới nhất dành cho bạn.</p>
                    <br></br>
                    <p>Make by Meomephim @ 2024</p>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
